import { setBmpListValue } from '@common/Tracking/BmpProductView/trackList';
import { formatListGroupData, getFormatListGroupData } from '@common/Tracking/helpers/GaHelpers';
import { isBooztmobile } from '@helpers/env';

export const handleBmpProductViewImpressionTracking = (settings = {}) => {
    const {
        currentPage = 1,
        group,
        productsPerPage = 120,
        totalProducts = 5,
        itemIndex,
        containerOffsetWidth = null,
        elementOffsetWidth = null,
        productsPerRow: productsPerRowProp = 1,
        navigationId,
        tagIds,
        path
    } = settings;

    const calculatedProductsPerRow = containerOffsetWidth && elementOffsetWidth
        ? Math.floor(containerOffsetWidth / elementOffsetWidth)
        : null;
    const productsPerRow = calculatedProductsPerRow ?? productsPerRowProp;
    const column = (itemIndex % productsPerRow) + 1;
    const row = Math.floor(itemIndex / productsPerRow) + 1;

    const position = ((currentPage * productsPerPage) - productsPerPage) + (((row * productsPerRow) - productsPerRow) + column);

    const listGroupDataExtraIds = [
        path && `path${path}`,
        navigationId && `nav${navigationId}`,
        tagIds && `tags${tagIds}`
    ];

    const data = getFormatListGroupData(
        {
            listGroupDataExtraIds,
            column,
            currentPage,
            group,
            position,
            productsPerRow,
            productsPerPage,
            row,
            totalProducts
        }
    );

    setBmpListValue(formatListGroupData(data, '|'));
};

// eslint-disable-next-line import/prefer-default-export
export const handleBmpProductViewImpression = (productElement) => {
    const navigationId = productElement.getAttribute('data-navigation-id');
    const tagIds = productElement.getAttribute('data-tag-ids');
    const pathId = productElement.getAttribute('data-path-id');
    const containerElement = productElement.parentElement;

    const index = [...containerElement.children].indexOf(productElement);
    const productsPerRow = Math.floor(containerElement.offsetWidth / productElement.offsetWidth);
    const row = Math.floor(index / productsPerRow) + 1;
    const column = (index % productsPerRow) + 1;

    const isFromCMS = containerElement.classList.contains('impressions-observer--cms');
    const group = isFromCMS
        ? productElement.getAttribute('data-listing-name')
        : containerElement.getAttribute('data-products-group');
    const isListingLayout = ['listing', 'brandwall'].indexOf(group) !== -1;
    const { dataset: containerDataset } = containerElement;
    const {
        currentPage = 1,
        productsPerPage = 120,
        totalProducts = 5
    } = isListingLayout ? App.Config.Listing.paging : containerDataset;
    const { tiAddPath } = containerDataset;
    const position = ((currentPage * productsPerPage) - productsPerPage) + (((row * productsPerRow) - productsPerRow) + column);
    const listGroupDataExtraIds = [
        pathId && `path${pathId}`,
        navigationId && `nav${navigationId}`,
        tagIds && `tags${tagIds}`
    ];

    const data = getFormatListGroupData(
        {
            listGroupDataExtraIds,
            column,
            currentPage,
            group,
            isFromCMS,
            position,
            productsPerRow,
            productsPerPage,
            row,
            totalProducts,
            tiAddPath
        }
    );

    setBmpListValue(formatListGroupData(data, '|'));
};

export const getProductCardContainers = () => {
    const {
        controller = '',
        action = ''
    } = document.body.dataset;

    const productCardContainers = [];
    const listingProducts = isBooztmobile() ? '#product_list_cont' : '#product-list-cont';

    if (controller === 'layout' && action === 'renderbyconfig') {
        const cmsProductsTemplate = document.querySelector('.cms-product-template--one');

        if (cmsProductsTemplate) {
            productCardContainers.push('.cms-product-template--one');
        }
    } else if (controller === 'listing' && action === 'list') {
        const listingProductsContainer = document.querySelector(listingProducts);

        if (listingProductsContainer) {
            productCardContainers.push(listingProducts);
        }
    } else if (controller === 'product' && action === 'view') {
        const relatedProductsContainer = document.querySelector('.product-list');

        if (relatedProductsContainer) {
            productCardContainers.push('.product-list');
        }
    }

    return productCardContainers;
};
